import { Component } from 'preact';
import { connect } from 'unistore/preact';
import { List } from './list';
import { formatList, filterList, clearSearch } from '../../controllers/select-ifsc';
import { selectIfscFromBank } from '../../controllers/bank-mandate';
import { locale } from '../../utils/i18n';

class SelectIfsc extends Component {
  constructor(props) {
    super(props);
    this.stateHeading = locale('bm.select.state');
    this.cityHeading = locale('bm.select.city');
    this.bankHeading = locale('bm.select.bank');
    this.stateListData = formatList(props.ifscStateData);
    this.bankListData = '';
    this.cityListData = '';
    this.openedList = 'state';
    this.state = {
      heading: '',
      listData: [],
      key: '',
      selectedState: ''
    };
    this.stateKey = 'state';
    this.bankKey = 'bank';
    this.cityKey = 'city';
    this.showStateList();
    this.ifscData = '';
  }

  backButtonFn = isData => {
    if (isData === true && this.ifscData) {
      this.props.closeSelectIfsc(true, this.ifscData);
    } else if (this.openedList === this.stateKey) {
      this.props.closeSelectIfsc(false, {});
    } else if (this.openedList === this.bankKey) {
      this.showCityList();
    } else if (this.openedList === this.cityKey) {
      this.showStateList();
    }
  };

  showStateList = () => {
    this.openedList = this.stateKey;
    this.setState({
      heading: this.stateHeading,
      listData: this.stateListData,
      key: this.openedList
    });
  };

  showCityList = () => {
    this.openedList = this.cityKey;
    this.setState({
      heading: this.cityHeading,
      listData: this.cityListData,
      key: this.openedList
    });
  };

  showBankList = () => {
    this.openedList = this.bankKey;
    this.setState({
      heading: this.bankHeading,
      listData: this.bankListData,
      key: this.openedList
    });
  };

  filterListData = e => {
    const stateData = filterList(e.target.value, this.props.bankList);
    this.setState(stateData);
  };

  clearSearchData = () => {
    this.search.value = '';
    const stateData = clearSearch(this.props.bankList);
    this.setState(stateData);
  };

  selectListData = data => {
    if (this.openedList === this.bankKey) {
      this.ifscData = data;
      this.backButtonFn(true);
    } else if (this.openedList === this.cityKey) {
      const apiData = {
        key: `${`${this.props.bank.channelCode}_${this.state.selectedState}_${data.displayName}`
          .split(' ')
          .join('_')}_IFSC_bank_list`,
        request: {
          bankName: this.props.bank.channelName,
          state: this.state.selectedState,
          city: data.displayName
        }
      };
      selectIfscFromBank(apiData.key, apiData.request, this.props.cache)
        .then(res => {
          this.bankListData = formatList(res.bankBranchList);
          this.showBankList();
        })
        .catch(error => {
          this.props.showSelectIFSCError(error);
        });
    } else if (this.openedList === this.stateKey) {
      this.setState({ selectedState: data.displayName });
      const apiData = {
        key: `${`${this.props.bank.channelCode}_${data.displayName}`
          .split(' ')
          .join('_')}_IFSC_city_list`,
        request: { bankName: this.props.bank.channelName, state: data.displayName }
      };
      selectIfscFromBank(apiData.key, apiData.request, this.props.cache)
        .then(res => {
          this.cityListData = formatList(res.list);
          this.showCityList();
        })
        .catch(error => {
          this.props.showSelectIFSCError(error);
        });
    }
  };

  render({}, { heading, listData, key }) {
    return (
      <List
        selectListData={this.selectListData}
        heading={heading}
        list={listData}
        placeholder={key}
        clearSearchData={this.clearSearchData}
        filterListData={this.filterListData}
        backButtonFn={this.backButtonFn}
      />
    );
  }
}

export default connect(
  'cache',
  null
)(SelectIfsc);



// WEBPACK FOOTER //
// ./components/select-ifsc/index.js